var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRepeatIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_51_708)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7259 6.52257L24.1011 0.897745C23.8329 0.629628 23.4298 0.549006 23.0792 0.695251C22.7286 0.841497 22.4999 1.18086 22.4999 1.5596V4.37201H10.3127C4.61667 4.37201 0.000564575 8.98812 0.000564575 14.6842C0.000564575 15.2017 0.420551 15.6217 0.938035 15.6217H4.68792C5.2054 15.6217 5.62539 15.2017 5.62539 14.6842C5.62539 12.0949 7.72345 9.99684 10.3127 9.99684H22.4999V12.8092C22.4999 13.188 22.7286 13.5311 23.0792 13.6755C23.4298 13.8217 23.8329 13.7411 24.1011 13.473L29.7259 7.84815C30.0915 7.48254 30.0915 6.88818 29.7259 6.52257Z",
    fill: "#396AFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.0621 15.6218H25.3122C24.7947 15.6218 24.3747 16.0418 24.3747 16.5593C24.3747 19.1486 22.2766 21.2467 19.6874 21.2467H7.50023V18.4342C7.50023 18.0555 7.27149 17.7124 6.92088 17.568C6.57026 17.4236 6.16903 17.5043 5.89903 17.7724L0.27421 23.3972C-0.0914034 23.7628 -0.0914034 24.3572 0.27421 24.7228L5.89903 30.3477C6.16715 30.6158 6.57026 30.6964 6.92088 30.5501C7.27149 30.4039 7.50023 30.0627 7.50023 29.6839V26.8715H19.6874C25.3834 26.8715 29.9995 22.2554 29.9995 16.5593C29.9995 16.0418 29.5795 15.6218 29.0621 15.6218Z",
    fill: "#396AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_51_708"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(0 0.622681)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRepeatIcon);
export default __webpack_public_path__ + "static/media/repeat-icon.8c84c0282c7e47712c3ddd85756e4cd6.svg";
export { ForwardRef as ReactComponent };